<section class="top">
  <div class="info">
    <h2 class="heading-4">{{ vm.claimType === 'service' ? 'Your annual service' : 'Your repair' }}</h2>
    @if (vm.claimType === 'service') {
      <p class="body mt-8">Your plan includes <strong>one service</strong> per year.</p>
      <p class="body">You'll get a reminder when it’s time to book your next one.</p>
    } @else {
      <p class="body mt-8">You have an unfinished booking.</p>
    }
  </div>
</section>

<hr class="divider mt-24 mb-24 md-mt-16 md-mb-16" />

<div class="actions">
  <app-button dataLabel="cancel-booking" [buttonOptions]="{ variant: 'secondary' }" (onClick)="cancelBooking()">
    Cancel booking
  </app-button>
  <app-button dataLabel="continue-booking" (onClick)="continueBooking()">
    Continue booking
    <i class="fa-light fa-arrow-right ml-8" aria-hidden="true"></i>
  </app-button>
</div>
